module.exports = __webpack_public_path__ + "img/14-Densen Shimbun.06b11616.jpg";